/* eslint-disable */
// @ts-nocheck

import React from 'react'

import {
  faBoxOpen,
  faCashRegister,
  faDiagramProject,
  faDollyBox,
  faFlask,
  faMinusSquare,
  faRefresh,
  faShoppingCart,
  faSignInAlt,
  faSignOutAlt,
  faSlidersH,
  faTrash,
  faUndo,
} from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import { translateOperation } from '../../../utils/translate'

function classNames(...classes: string[]) {
  return classes.filter(Boolean).join(' ')
}

const getColorMovementsOperationType = (value?: string | null) => {
  let data = ''

  switch (value) {
    case 'ENTRY':
      data = 'bg-emerald-100 text-emerald-800'
      break
    case 'MOVEMENT':
    case 'TRASLATE':
      data = 'bg-blue-100 text-blue-800'
      break
    case 'OUT':
    case 'DISPATCH':
      data = 'bg-orange-100 text-orange-800'
      break
    case 'EXIT':
    case 'EXTRACTION':
      data = 'bg-red-100 text-red-800'
      break
    case 'PROCESSED':
    case 'ELABORATION':
      data = 'bg-purple-100 text-purple-800'
      break
    case 'REMOVED':
      data = 'bg-red-100 text-red-800'
      break
    case 'ADJUST':
      data = 'bg-yellow-100 text-yellow-800'
      break
    case 'WASTE':
      data = 'bg-purple-100 text-purple-800'
      break
    case 'TRANSFORMATION':
    case 'DESCOMPOSITION':
      data = 'bg-slate-100 text-slate-800'
      break
    case 'SALE':
      data = 'bg-green-100 text-green-800'
      break
    case 'BUY':
      data = 'bg-blue-100 text-blue-800'
      break
    case 'FAST_ENTRY':
      data = 'bg-emerald-100 text-emerald-800'
      break
    case 'CONTAINER':
      data = 'bg-gray-100 text-gray-800'
      break
    case 'REFUNDED':
      data = 'bg-orange-100 text-orange-800'
      break
    default:
      data = 'bg-fuchsia-100 text-fuchsia-800'
  }

  return data
}

const getOperationIcon = (operation?: string | null) => {
  switch (operation) {
    case 'MOVEMENT':
    case 'TRASLATE':
      return faDollyBox

    case 'OUT':
    case 'DISPATCH':
      return faSignOutAlt

    case 'EXIT':
    case 'EXTRACTION':
      return faSignOutAlt

    case 'PROCESSED':
    case 'ELABORATION':
      return faDiagramProject

    case 'REMOVED':
      return faTrash

    case 'ADJUST':
      return faSlidersH

    case 'WASTE':
      return faMinusSquare

    case 'SALE':
      return faCashRegister

    case 'BUY':
      return faShoppingCart

    case 'FAST_ENTRY':
      return faSignInAlt

    case 'TRANSFORMATION':
      return faRefresh

    case 'DESCOMPOSITION':
      return faFlask

    case 'CONTAINER':
      return faBoxOpen

    case 'REFUNDED':
      return faUndo

    default:
      return faSignInAlt
  }
}

interface MovementBadgeInterface {
  operation?: string | null
}

const MovementsTypeBadge = ({ operation }: MovementBadgeInterface) => {
  return (
    <div
      className={classNames(
        getColorMovementsOperationType(operation),
        'inline-flex h-7 items-center gap-x-1 rounded-full px-2.5 py-0.5 text-sm font-medium md:mt-2 lg:mt-0'
      )}
    >
      <FontAwesomeIcon
        className={classNames(getColorMovementsOperationType(operation))}
        icon={getOperationIcon(operation)}
      />
      {translateOperation(operation)}
    </div>
  )
}

export default MovementsTypeBadge
